import { map } from 'lodash';
import type { IDashboardItem } from './DashboardItem.interface';

export default class DashboardItem implements IDashboardItem {
  name: string;
  key: string;
  loc: Array<number>;
  dim: Array<number>;
  min: Array<number>;
  max: Array<number>;

  static build = (data: IDashboardItem) => new DashboardItem(data);
  static blank = () => new DashboardItem();

  /**
   * Constructor
   * @param {IDashboardItem} data
   */
  constructor(data?: IDashboardItem) {
    this.name = data?.name || '';
    this.key = data?.key || '';
    this.loc = map(data?.loc, (obj) => parseInt(obj || 0, 10));
    this.dim = map(data?.dim, (obj) => parseInt(obj || 0, 10));
    this.min = map(data?.min, (obj) => parseInt(obj || 0, 10));
    this.max = map(data?.max, (obj) => parseInt(obj || 0, 10));
  }
}
